<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="450">
      <template v-slot:activator="{ on }">
        <v-btn small flat color="error" dark v-on="on">retirer</v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Retrait PM</v-card-title>
        <v-flex xs12 text-xs-center mb-3>
          <img src="/img/perfectmoney.png" alt="perfectmoney" width="70" height="70" />
        </v-flex>
        <v-card-text>
          <v-form ref="form" v-if="formulaire">
            <v-layout row wrap>
              <v-flex xs8>
                <v-text-field
                  solo
                  type="number"
                  class="first pl-2"
                  label="Montant"
                  v-model="amount"
                  append-icon="attach_money"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 justify-end>
                <!-- <v-btn color="primary" @click="tout">Max</v-btn> -->
                <p class="mt-2">frais: {{fee}}</p>
              </v-flex>
            </v-layout>
            <p class="font-weight-bold ml-5">TOTAL : {{total}}</p>
            <v-text-field
              class="pm_account"
              solo
              label="compte PM"
              :rules="nameRules"
              v-model="pm_account"
            ></v-text-field>

            <v-flex xs12 text-xs-center>
              <v-btn type="submit" color="success" @click.prevent="submit() ">Retirer</v-btn>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <p class="red--text subheader" v-if="hmm">solde insuffisant</p>
            </v-flex>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="dialog = false">fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div  id="rendu" v-show="false"></div>

    <div>
      <v-dialog v-model="dialog_2fa" max-width="800">
        <v-card>
          <v-card-title class="headline grey lighten-2 pa-3" primary-title>
            <div style="display:block; text-align:center; margin:auto;">Google 2-FA</div>
          </v-card-title>

          <v-card-text class="px-3 pt-1 mb-4">
            <div style="display:block; max-width:100%; text-align:center">
              <img src="/img/2fa.svg" width="70" alt />
            </div>
            <p
              class="caption"
              style="display:block; max-width:100%; text-align:center"
            >Entrez le code à 6 chiffres pour confirmer le retrait</p>
            <div class="pl-4" style="text-align:center">
              <input
                class="code"
                v-model="code"
                type="number"
                onkeypress="if(this.value.length==6) return false;"
              />
              <br />
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog_2fa= false">fermer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>


<script>
import firebase from "../../../fb";
import db from "../../../db";
import { mapGetters } from "vuex";
var bcrypt = require("bcryptjs");
import axios from "axios";
export default {
  data() {
    return {
      pass: process.env.VUE_APP_SECRET,
      code: "",
      dialog_2fa: false,
      hmm: false,
      formulaire: true,
      amount: "",
      pm_account: "",
      name: "",
      dialog: false,
      fired:false,
      nameRules: [
        (v) => !!v || "obligatoire",
        (v) => /^[U][0-9]{8}?$/.test(v) || "invalid account",
      ],
      fee: null,
    };
  },
  computed: {
    total() {
      return Number(this.amount) + Number(this.fee);
    },
    ...mapGetters({
      pm: "authfb/pm",
      user: "authfb/user",
    }),
  },
  watch: {
    amount(newValue, oldValue) {
      this.fee = 0.005 * newValue;
    },
    code(newValue, oldValue) {
      if (newValue.length == 6) {
        this.validate();
      }
    },
  },
  methods: {
    tout() {
      var pm = Number(this.$store.getters["authfb/pm"]);
      this.amount = Math.floor(pm);
    },
    async dispatchWithdraw() {
      let sendAmount = Number(this.amount);
      this.$store
        .dispatch("withdraw/retraitPm", {
          sendAmount: Number(sendAmount),
          amount: this.total,
          account: this.pm_account,
          fee: Number(this.fee),
          base_url: this.base_url,
          vm:this
        })
        .then(() => {
          this.formulaire = false;
          this.dialog_2fa = false;
          this.amount = "";
          setTimeout(() => {
            this.formulaire = true;
          }, 5000);
        });
    },

    submit() {
      
      console.log('hii fired');

      let pm = Number(this.$store.getters["authfb/pm"]);
      let sendAmount = Number(this.amount);

      let payload = {
        sendAmount: Number(sendAmount),
        amount: this.total,
        account: this.pm_account,
      };

      console.log(payload);

      if (this.$refs.form.validate()) {
        if (this.amount > 0) {
          if (this.amount >= 5) {
            if (this.total <= pm) {
              this.dialog = false;

              if (this.user.auth2fa.google) {
                this.dialog_2fa = true;
                return;
              }

              swal({
                text: "CODE PIN",
                content: {
                  element: "input",
                  attributes: {
                    placeholder: "Enter PIN",
                    type: "password",
                  },
                },
                button: {
                  text: "confirm",
                  closeModal: false,
                },
              }).then((value) => {
                var hash = this.$store.getters["authfb/pin"];
                bcrypt.compare(value, hash).then((res) => {
                  if (res) {
                    this.dispatchWithdraw();
                  } else {
                    swal("incorrect PIN!", "", "error", {
                      button: "ok",
                    });
                    this.dialog = true;
                  }
                });
              });
            } else {
              swal("Solde insuffisant!", "", "error", {
                button: "ok!",
              });
            }
          } else {
            swal("Montant minimum 5 $", "veillez changer le montant", "error", {
              button: "ok",
            });
          }
        }
      }
    },

    validate() {
      let token = this.code
        let valid = this.verify_2fa(token)
        console.log(valid);

        if (valid) {
            this.dispatchWithdraw();
            this.dialog_2fa = false
            this.code = "";

            const noti = this.$vs.notification({
                  color: 'success',
                  position: 'top-right',
                  title: 'Success',
                  text: '2FA correct, retrait en cours'
                })
            
          } else {
            this.$vs.loading().close();
            swal("code 2FA invalide!", "", "error", {
              button: "ok!",
            });
            this.code = "";
          }
    },
  },
};
</script>

<style scoped>
.first {
  font-size: 2em;
  max-width: 190px;
  font-weight: 400;
  display: block;
}
.pm_account {
  font-size: 2em;
  max-width: 250px;
  display: block;
  margin: auto;
}
.fee {
  max-width: 200px;
  display: block;
  margin: auto;
}
</style>
